<template>
  <!--Disabled until Elie provides the pricing-->
  <!--<p class="font-weight-bold">${{accessory?.price}}</p>-->
  <div class="d-flex align-center justify-space-between">
    <div>
      <Tooltip location="top" text="Remove this accessory" v-if="dataset?.selected">
        <v-btn :disabled="default_attached" id="small-button" rounded="pill" color="error" class="ml-5" width="65" size="small"
          variant="outlined" @click="$emit('unselect')">Remove</v-btn>
      </Tooltip>
      <Tooltip location="top" text="Add this accessory" v-else>
        <v-btn :color="ConfigElementsColor" class="ml-5" rounded="pill" prepend-icon="mdi-plus" size="small"
          @click="$emit('select')">Add</v-btn>
      </Tooltip>
      <v-tooltip v-if="default_attached" target="small-button" activator="parent" location="right">
        This accessory is attached by default
      </v-tooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'
import Tooltip from "@/components/typography/Tooltip.vue"

const props = defineProps<{
  accessory: any
  dataset: any
  datasets: any
}>()

defineEmits<{
  (e: 'select'): void
  (e: 'unselect'): void
}>()

const store = useGlobalsStore()
const { ConfigElementsColor } = storeToRefs(store)

const default_attached = computed(() => {
  return props.dataset?.default_attached == 1
})
</script>
